import { Component, Input, ViewChild } from '@angular/core';
import { SwiperComponent } from 'library-explorer';

@Component({
    selector: 'app-testimonials',
    templateUrl: './testimonials.component.html',
    styleUrls: ['./testimonials.component.scss'],
    standalone: false
})
export class TestimonialsComponent {

  @ViewChild(SwiperComponent) swiperComponent: SwiperComponent;

  @Input() block: any;

  public swiperOptions = {
    centeredSlides: true,
    spaceBetween: 0,
    slidesPerView: 'auto',
    showOverflow: true
  };

  constructor() { }

}
